<template>
    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="single-team text-center radius-100 overflow-hidden m-2 m-lg-0">
            <!-- Team Thumb -->
            <div class="team-thumb radius-100 d-inline-block position-relative overflow-hidden">
                <img :src="data.photo" alt="Member photo">
                <!-- Team Overlay -->
                <div class="team-overlay radius-100">
                    <h4 class="team-name text-white">{{data.name}}</h4>
                    <h5 class="team-post text-white mt-2 mb-3">{{data.title}}</h5>
                    <!-- Team Icons -->
                    <div class="team-icons">
                        <a class="p-2" href="#"><i class="fab fa-facebook-f"></i></a>
                        <a class="p-2" href="#"><i class="fab fa-twitter"></i></a>
                        <a class="p-2" href="#"><i class="fab fa-google-plus-g"></i></a>
                        <a class="p-2" href="#"><i class="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TeamMember',
    props: ['data']
}
</script>

<style>

</style>